import styled from 'styled-components';

import {
  green,
  black,
  lightBlue,
  lightGreen,
  whitesmoke,
} from 'utils/style/colors';

interface IButtonGroupWrapper {
  width?: string;
}
interface IStyledProps {
  isActive: boolean;
  flexBasis?: number;
  withoutPadding?: boolean;
  fromOther?: boolean;
  fromParent?: boolean;
}

export const ButtonGroupWrapper = styled('div')<IButtonGroupWrapper>`
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  background-color: ${whitesmoke};
  width: ${(props) => (props.width ? props.width : '100%')};
`;

export const ButtonSpan = styled('div')<IStyledProps>`
  flex: ${(props) =>
    props.flexBasis ? `1 1 ${props.flexBasis}%` : '1 1 auto'};
  cursor: ${(props) => (props.isActive ? 'default' : 'pointer')};
  color: ${(props) => (props.isActive ? 'white' : black)};
  background-color: ${(props) =>
    props.isActive
      ? green
      : props.fromParent
        ? lightBlue
        : props.fromOther
          ? lightGreen
          : undefined};
  text-align: center;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.isActiv && 'transform: scale(1.1)'}

  height: 36px;
  font-weight: ${(props) => (props.isActive ? '500' : '400')};
  line-height: 36px;
  padding: ${(props) => (props.withoutPadding ? '0' : '0 0.5rem')};
  vertical-align: middle;
  font-size: 12px;
  border-radius: 10px;
  &:hover {
    color: ${(props) => (props.isActive ? 'white' : green)};
  }
  &:focus {
    background-color: ${whitesmoke};
  }
  & > input {
    max-width: 45px;
    height: 100% !important;
    padding: 0 0.5em !important;
    border: none !important;
  }
`;
